export default {
  issueDetail: {
    title: '発行明細',
    qrCode: 'QRコード',
    qrCodePlaceholder: 'QRコードを入力してください',
    productInfo: '商品情報',
    productInfoPlaceholder: 'キーワードで検索してください',
    relatedInfo: '関連情報',
    relatedInfoPlaceholder: 'キーワードで検索してください',
    memberInfo: '会員情報',
    memberInfoPlaceholder: '会員情報',
    issueTime: '発行時間',
    country: '国',
    issuePoints: '発行ポイント',
    spec: '仕様',
    singleSpec: '単一仕様',
    memberId: '会員情報',
    direction: '方向',
    directionAdd: '増加',
    directionSubtract: '減算',
    directionFreeze: '凍結',
    directionUnfreeze: '解凍',
    points: 'ポイント',
    beforePoints: '変更前',
    afterPoints: '変更後',
    sourceType: 'ソースタイプ',
    sourceTypeScan: 'スキャン',
    sourceTypeActivity: 'アクティビティ',
    sourceTypeManual: '手動',
    sourceTypeMall: 'モール',
    sourceTypeRedPacket: '赤包',
    sourceName: 'ソース名',
    remark: '備考',
    timeRequired: '発行時間を選択してください',
  },
  issueStats: {
    title: '発行統計',
    date: '日付',
    totalIssued: '総発行データ',
    totalConsumed: '総消費データ',
    chartTitle: '過去7日間のポイント発行状況',
    rankTitle: 'ポイント発行商品ランキング',
    rankNo: '順位',
    productDetail: '商品詳細',
    totalPoints: '総発行ポイント',
    spec: '仕様',
    singleSpec: '単一仕様',
  },
  config: {
    title: '基本設定/ポイントルール',
    language: '言語',
    addLang: '多言語を追加',
    deleteLang: '多言語を削除',
    deleteLangConfirm: '現在の言語設定を削除してもよろしいですか？',
    ruleTitle: 'タイトル',
    content: '内容',
    addLangModalTitle: '多言語を追加',
    languagePlaceholder: '言語を選択してください',
  },
};
